import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import i_ from 'i18next';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import NavigationMore from '@material-ui/icons/MoreHoriz';

import more from '../assets/more.svg';

import AuthenticationStore from '../stores/AuthenticationStore';
import SelecaoStore from '../stores/SelecaoStore';
import UIStore from '../stores/UIStore';

import AsideBar from './AsideBar';
import ConfirmDialog from './commons/ConfirmDialog';
import { ArrowDropDown } from '@material-ui/icons';
import { baseUrl } from '../utils/Client';

const styles = theme => ({
  topBar: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: '6px',
      paddingRight: '6px',
    },
  },
  menuButton: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  logoContainer: {
    [theme.breakpoints.up('md')]: {
      margin: '20px 0 20px 0',
      paddingRight: '36px',
    },
    [theme.breakpoints.down('md')]: {
      paddingRight: '12px',
    },
    borderRight: `2px solid ${theme.palette.grey[300]}`,
    marginTop: '5px',
    marginBottom: '5px',
  },
  logoImage: {
    height: '82px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  logoIcon: {
    height: '46px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  topContainer: {
    display: 'flex',
    width: '100%',
    paddingLeft: '16px',
    verticalAlign: 'top',
    justifyContent: 'space-between',
  },
  titleContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  rodadasContainer: {
    display: 'flex',
    alignItems: 'baseline',
  },
  rodadasContainerTitle: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  cargoContainer: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    display: 'flex',
    alignItems: 'center',
    flex: 0.9,
  },
  cargoContainerText: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  roundButtons: {
    [theme.breakpoints.up('md')]: {
      borderRadius: '48px',
      minWidth: '48px',
      minHeight: '48px',
    },
    [theme.breakpoints.down('md')]: {
      borderRadius: '32px',
      minWidth: '32px',
      minHeight: '32px',
      padding: 0,
    },
    border: '2px solid #ff9100',
    color: 'black',
    fontWeight: 'bold',
    margin: '5px',
  },
  roundButtonSelected: {
    borderColor: theme.palette.primary.main,
  },
  showMenu: {},
});

class MainBar extends React.Component {
  state = { anchorElUsuario: null, anchorElCargo: null };

  handleToggle = () => UIStore.asideOpen();

  handleSair = () =>
    AuthenticationStore.logout().then(() => this.props.history.push('/login'));

  handleMenuUsuario = event =>
    this.setState({ anchorElUsuario: event.currentTarget });

  handleCloseUsuario = () => this.setState({ anchorElUsuario: null });

  handleMenuCargo = event =>
    this.setState({ anchorElCargo: event.currentTarget });

  handleCloseCargo = () => this.setState({ anchorElCargo: null });

  handleSetCargo = cargo =>
    AuthenticationStore.setCargo(cargo)
      .then(this.handleCloseCargo)
      .then(AuthenticationStore.testAuthenticated)
      .then(() => this.props.history.push('/'));

  getUserMenu = () => {
    let { anchorElUsuario } = this.state;
    let open = Boolean(anchorElUsuario);
    return (
      <React.Fragment>
        <Button
          size="small"
          variant="outlined"
          color="default"
          className={this.props.classes.roundButtons}
          style={{ borderColor: '#ccc' }}
          onClick={this.handleMenuUsuario}
        >
          <NavigationMore />
        </Button>
        <Menu
          anchorEl={anchorElUsuario}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={this.handleCloseUsuario}
        >
          <MenuItem leftIcon={<AccountCircle />}>
            {AuthenticationStore.me.nome}
          </MenuItem>
          <Divider />
          <MenuItem onClick={this.handleSair}>{i_.t('logout')}</MenuItem>
        </Menu>
      </React.Fragment>
    );
  };

  render() {
    let isAdmin = AuthenticationStore.hasRole('ADMIN');
    let { anchorElCargo } = this.state;
    let { classes, width } = this.props;
    let { cargo, cargos, pesquisa } = AuthenticationStore.me;
    let rodada = SelecaoStore.rodadaSelecionada;
    let onUpdate = UIStore.onUpdate;
    return (
      <React.Fragment>
        {cargos && (
          <Menu
            anchorEl={anchorElCargo}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElCargo)}
            onClose={this.handleCloseCargo}
          >
            {cargos.map(c => (
              <MenuItem key={c.id} onClick={() => this.handleSetCargo(c)}>
                {c.nome}
              </MenuItem>
            ))}
          </Menu>
        )}
        <AppBar>
          <Toolbar elevation={0} className={classes.topBar}>
            <Button
              size="small"
              color="default"
              onClick={this.handleToggle}
              className={classNames(classes.menuButton)}
            >
              <img src={more} alt="More button" />
            </Button>

            <div className={classes.logoContainer}>
              <img
                className={classes.logoImage}
                src={baseUrl + '/img/logo.png'}
                alt="logo"
              />
            </div>

            <div className={classes.topContainer}>
              <div className={classes.titleContainer}>
                <Typography variant="title" style={{ fontWeight: 'bold' }}>
                  {pesquisa ? pesquisa.nome : 'Usuário Sem Pesquisa'}
                </Typography>
                <Typography variant="title">
                  <span style={{ fontWeight: 'bold' }}>Cargo: </span>
                  {cargo ? (
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={this.handleMenuCargo}
                    >
                      {cargo.nome}
                    </a>
                  ) : (
                    'Selecione um cargo.'
                  )}
                </Typography>
              </div>

              <div className={classes.rodadasContainer}>
                <Typography
                  variant="title"
                  className={classes.rodadasContainerTitle}
                >
                  Rodadas:
                </Typography>
                {pesquisa
                  ? pesquisa.rodadas
                      .filter(r => r.aprovada || isAdmin)
                      .map(r => (
                        <Button
                          key={r.id}
                          className={classNames(classes.roundButtons, {
                            [classes.roundButtonSelected]:
                              rodada && rodada.id === r.id,
                          })}
                          onClick={() => {
                            SelecaoStore.selecionarRodada(r.numero);
                            if (onUpdate) {
                              onUpdate(r);
                            }
                          }}
                        >
                          {r.numero}
                        </Button>
                      ))
                  : ''}
              </div>

              <div className={classes.cargoContainer}>
                {cargo && (
                  <a
                    className={classes.cargoContainerText}
                    onClick={this.handleMenuCargo}
                  >
                    {cargo.nome}
                    <ArrowDropDown />
                  </a>
                )}
              </div>

              {this.getUserMenu()}
            </div>
          </Toolbar>
        </AppBar>

        <Button
          variant="fab"
          color="default"
          onClick={this.handleToggle}
          style={{
            position: 'fixed',
            zIndex: '99999',
            top: '144px',
            left: '16px',
            visibility:
              UIStore.asideOpened ||
              width === 'xs' ||
              width === 'sm' ||
              width === 'md'
                ? 'hidden'
                : 'visible',
          }}
        >
          <MenuIcon />
        </Button>

        <Snackbar
          autoHideDuration={4000}
          open={UIStore.snackOpened}
          message={UIStore.snackMessage}
          onRequestClose={() => (UIStore.snackOpened = false)}
        />
        <AsideBar asideOpen={UIStore.asideOpened} />
        <ConfirmDialog />
      </React.Fragment>
    );
  }
}

export default withRouter(withWidth()(withStyles(styles)(observer(MainBar))));



// WEBPACK FOOTER //
// ./src/components/MainBar.js